import { Stack } from '@chakra-ui/layout';
import { Skeleton } from '@chakra-ui/skeleton';
import React, { useEffect, useState } from 'react';
import { Transaction } from '../../../../model/Transaction';
import { paisaToRupee } from '../../../../utils';
import classes from './styles.module.scss';
import SDCard from '../../../../components/UI/SKCard';
import { format } from 'date-fns';
import useService from '../../../../hooks/useService';
import { WalletService } from '../../../../service/WalletService';
import InfiniteScroll from 'react-infinite-scroll-component';
import { StorageService } from '../../../../service/Storage';
import { Box, Image } from '@chakra-ui/react';
import Nodata from '../../../../assets/nodata.png';
/**
 *
 *
 * @param {{data :Transaction[] }}
 * @returns
 */
export default function TransactionHistory() {
  const [page, setPage] = useState(1);
  const trnxCtrl = useService(
    WalletService.getTransactionHistory,
    [],
    function formator(newData, oldData) {
      if (!newData && !oldData) return null;
      newData = newData || [];
      oldData = oldData || [];
      return [...oldData, ...newData];
    }
  );
  useEffect(() => {
    if (!StorageService.getAccessToken() || !StorageService.getWId()) return;
    trnxCtrl.call(StorageService.getWId(), page);
  }, [page]);

  return (
    <div className={classes.TransactionHistory}>
      {trnxCtrl.isLoading && !trnxCtrl.data ? (
        <Stack>
          <Skeleton height="20px" />
          <Skeleton height="20px" />
          <Skeleton height="20px" />
        </Stack>
      ) : !trnxCtrl.data ? (
        <Box
          className={classes.empty}
          fontWeight={'semibold'}
          fontSize={'24px'}
        >
          {' '}
          <Box
            display={'flex'}
            flexDirection="column"
            gap={2}
            alignItems="center"
            pt={6}
          >
            <Image width="150px" src={Nodata} alt="No Data" />
            <Box color={'#111111'}>No Withdrawal History</Box>
            <Box
              color={'#777'}
              fontSize="14px"
              fontWeight={400}
              textAlign="center"
            >
              You haven’t withdrawn any money. Please do more offers and
              withdraw your money.
            </Box>
          </Box>
        </Box>
      ) : (
        <div className={classes.list} id="transactionHistoryId">
          <InfiniteScroll
            dataLength={trnxCtrl?.data?.length || 0}
            next={() => {
              setPage(v => v + 1);
            }}
            hasMore={true}
            loader={
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  padding: '1rem',
                }}
              >
                <Stack>
                  <Skeleton height="20px" />
                  <Skeleton height="20px" />
                </Stack>
              </div>
            }
            scrollableTarget="transactionHistoryId"
            className={classes.scrollView}
          >
            {trnxCtrl.data.map((d, i) => (
              <TransactionRow data={d} key={i} />
            ))}
          </InfiniteScroll>
        </div>
      )}
    </div>
  );
}
/**
 *
 * @param {{data :Transaction}}
 * @returns
 */
const TransactionRow = ({ data }) => (
  <SDCard className={classes.TransactionRow}>
    <div className={classes.content}>
      <div className={classes.title}>
        Payment{' '}
        <span style={{ textTransform: 'capitalize' }}>
          {data.paymentStatus.toLowerCase()}
        </span>
      </div>
      <div className={classes.subtitle}>{format(data.createdAt, 'PP')}</div>
    </div>
    <div className={classes.amount}>₹ {paisaToRupee(data.valueInPaise)}</div>
    {data.errorReason && (
      <div className={classes.errorReason}>{data.errorReason}</div>
    )}
  </SDCard>
);
